import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthleteAppointment, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCancelAthleteAppointment(): UseMutationResult<
  AxiosResponse<null | AthleteAppointment>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const cancelAthleteAppointment = (
    athleteAppointmentId: string,
  ): Promise<AxiosResponse<null | AthleteAppointment>> => {
    return client.post(`athlete-appointments/${athleteAppointmentId}/cancel/`);
  };

  return useMutation(cancelAthleteAppointment, {
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ['athleteAppointments'] });
      queryClient.invalidateQueries({ queryKey: ['athleteEvents'] });
      queryClient.invalidateQueries({ queryKey: ['appointments'] });
      queryClient.invalidateQueries({ queryKey: 'events' });
      queryClient.invalidateQueries({ queryKey: ['totalAttended'] });
      queryClient.invalidateQueries({ queryKey: ['totalReserved'] });
    },
  });
}
